/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   form.grid[_ngcontent-%COMP%]   .large-input-group[_ngcontent-%COMP%]{margin-left:0;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:column;flex-direction:column;margin-bottom:10px}[_nghost-%COMP%]   form.grid[_ngcontent-%COMP%]   .large-input-group[_ngcontent-%COMP%]   .large-input[_ngcontent-%COMP%]:last-of-type{border:0;border-radius:0 0 4px 4px}[_nghost-%COMP%]   .pnr-input-wrapper[_ngcontent-%COMP%]     input{text-transform:uppercase}"];
export { styles as styles };
